import { useMemo } from "react";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import { Zap } from "lucide-react";
import { PALETTE, fmt, fmtMoney, KPI } from "./_shared";

export function EnergyTab({ overview, rows }) {
  const monthly = useMemo(() => {
    const m = {};
    for (const r of rows) {
      const key = r.period_month;
      const b = m[key] || (m[key] = { period_month: key, electricity_kwh: 0, gas_mj: 0, solar_generated_kwh: 0 });
      b.electricity_kwh += r.electricity_kwh || 0;
      b.gas_mj += r.gas_mj || 0;
      b.solar_generated_kwh += r.solar_generated_kwh || 0;
    }
    return Object.values(m).sort((a, b) => a.period_month.localeCompare(b.period_month))
      .map((x) => ({ ...x, label: x.period_month.slice(5) }));
  }, [rows]);

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <KPI label="Electricity (kWh)"    value={fmt(overview.energy.electricity_kwh)} hint="Grid + solar consumed" icon={Zap} tone="brand" />
        <KPI label="Gas (MJ)"             value={fmt(overview.energy.gas_mj)}          hint="Natural gas" tone="warn" />
        <KPI label="Solar Generated (kWh)" value={fmt(overview.energy.solar_generated_kwh)} hint="On-site PV" tone="good" />
        <KPI label="Energy Spend"         value={fmtMoney(overview.energy.cost)} icon={Zap} />
      </div>
      <div className="rounded-lg border border-slate-200 bg-white p-4">
        <div className="text-sm font-medium text-slate-800 mb-2">Energy Consumption vs Solar Generation — Monthly</div>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={monthly}>
            <CartesianGrid strokeDasharray="3 3" stroke="#F1F5F9" />
            <XAxis dataKey="label" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} tickFormatter={(v) => `${(v/1000).toFixed(0)}k`} />
            <Tooltip formatter={(v) => fmt(v)} contentStyle={{ fontSize: "12px" }} />
            <Legend wrapperStyle={{ fontSize: "11px" }} />
            <Line type="monotone" dataKey="electricity_kwh"     name="Electricity kWh" stroke={PALETTE.s2}    strokeWidth={2.5} />
            <Line type="monotone" dataKey="gas_mj"              name="Gas MJ"          stroke={PALETTE.amber} strokeWidth={2}   />
            <Line type="monotone" dataKey="solar_generated_kwh" name="Solar kWh"       stroke={PALETTE.emerald} strokeWidth={2.5} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
